import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

export default function DigitalPilotPitch() {
  return (
    <div className="uk-width-1-1 uk-flex uk-flex-middle" data-uk-grid="true">
      <Link to="/nacc-collaborations/digital-biomarker-pilots" target="_blank" rel="noreferrer">
        <StaticImage
          src="../../../../images/home-updates/pilot-pitch.png"
          alt=" Introducing the Pitch Competition on May 31, 2024 "
          className="uk-width-1-1"
        />
      </Link>
    </div>
  );
}
